// TODO move to packages
import {
  SUBSCRIPTION_PLAN,
  SUBSCRIPTION_PLAN_PRICE
} from '@gymaholic/packages'

export const SUBSCRIPTION_PLAN_YEARLY_SAVINGS = {
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM] * 12 -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_YEARLY],

  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_2025] * 12 -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025],

  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025] * 12 -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025],

  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025] * 12 -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025],

  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025] * 12 -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]
}

export const SUBSCRIPTION_PLAN_MONTHLY_SAVINGS = {
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025] -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025],

  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025]:
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025] -
  SUBSCRIPTION_PLAN_PRICE[SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]

}
